import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Link, useNavigate } from 'react-router-dom';
import { Button, TextField, Paper, Typography, Box, Alert, CircularProgress } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import EmailIcon from '@mui/icons-material/Email';
import { register, auth } from '../../services/user-services';

function Register() {

  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const passMatch = () => {
    return password === password2;
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!passMatch()) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await register({ username, email, password, profile: { is_premium: false } });
      const data = await auth({ username, password });
      setAuth(data);
      navigate('/account');
    } catch (err) {
      setError(err.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="70vh">
      <Paper elevation={0} sx={{ p: 4, borderRadius: 3, backgroundColor: 'background.paper', width: '100%', maxWidth: 400, border: '1px solid rgba(255,255,255,0.05)' }}>
        <Typography variant="h2" align="center" gutterBottom color="primary">
          Join BWF
        </Typography>
        <Typography variant="body2" align="center" color="text.secondary" mb={4}>
          Create an account to start joining groups
        </Typography>

        <form onSubmit={handleSubmit}>
          <Box mb={2}>
            <TextField
              fullWidth
              label="Username"
              variant="outlined"
              onChange={e => setUsername(e.target.value)}
              InputProps={{ startAdornment: <AccountCircleIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
            />
          </Box>
          <Box mb={2}>
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              onChange={e => setEmail(e.target.value)}
              InputProps={{ startAdornment: <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
            />
          </Box>
          <Box mb={2}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              variant="outlined"
              onChange={e => setPassword(e.target.value)}
              InputProps={{ startAdornment: <VpnKeyIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
            />
          </Box>
          <Box mb={3}>
            <TextField
              fullWidth
              label="Repeat Password"
              type="password"
              variant="outlined"
              onChange={e => setPassword2(e.target.value)}
              InputProps={{ startAdornment: <VpnKeyIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
            />
          </Box>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Button fullWidth color="primary" variant="contained" type='submit' size="large" sx={{ mb: 2 }} disabled={loading} startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}>
            {loading ? 'Registering...' : 'Register'}
          </Button>
        </form>

        <Box textAlign="center" mt={2}>
          <Link to={"/login"} style={{ color: '#ff9800', fontSize: '0.875rem' }}>
            Already have an account? Login here
          </Link>
        </Box>
      </Paper>
    </Box>
  );
}

export default Register;